define('home/views/DiscussionBannerView',[
    'backbone-marionette',

    'home/mixins/withChannelBanner',
    'core/mixins/withChannelFollowing',
    'home/mixins/withClickLinkTracking',

    'home/templates/discussionBanner',
], function (
    Marionette,

    withChannelBanner,
    withChannelFollowing,
    withClickLinkTracking,

    discussionBannerTemplate
) {
    'use strict';

    /**
     * View is the cover view on the discussion page.
     * It has logo or channel name and in mobile, follow button.
     *
     * Expects channel as model.
     */
    var DiscussionBannerView = Marionette.ItemView.extend({
        template: discussionBannerTemplate,

        events: {
            'click a': 'trackClickLink',
        },

        initialize: function (options) {
            this.app = options.app;
            this.session = options.session;

            // toggled:follow event is triggered by the withChannelFollowing
            // mixin when a user clicks on the follow button. Rerender to update
            // the onboarding message.
            this.listenTo(this, 'toggled:follow', this.render);
        },
    });

    var proto = DiscussionBannerView.prototype;

    withClickLinkTracking.call(proto, 'discussion_top_banner');
    withChannelBanner.call(proto);

    withChannelFollowing.call(proto, function () {
        return this.model;
    });

    return DiscussionBannerView;
});

